import { initializeApp } from "firebase/app";
import { getMessaging, onMessage } from "firebase/messaging";
import config from "./config";
import { isWebView } from "./utils/helpers";

const firebaseConfig = {
  apiKey: config.apiKey,
  authDomain: config.authDomain,
  projectId: config.projectId,
  storageBucket: config.storageBucket,
  messagingSenderId: config.messagingSenderId,
  appId: config.appId,
};
export const app = initializeApp(firebaseConfig);
let messaging;

// 04.10: ?diag=nofb — диагностика падения iOS Safari (см. public/index.html)
const firebaseDiagOff =
  typeof window !== "undefined" && window.__diagOff && window.__diagOff("nofb");
if (!isWebView() && !firebaseDiagOff) {
  // Только если это не RN WebView
  try {
    messaging = getMessaging(app);

    // foreground-уведомления
    onMessage(messaging, (payload) => {
      console.log("Message received in browser. ", payload);
    });
  } catch (e) {
    console.warn("Firebase messaging not supported in this environment", e);
  }
}

export { messaging };
